<!--
****** NOTES: ******
- badge type "is-inverted" should be "is-primary-inverted"
- badge type "is-removed" should be "is-alert" (also its using $un-red-lighter instead of $un-red)
- "is-added" / "is-success" and "is-removed" are related to appending a string to a value. (should only be a color scheme, unless value is typeof number)
- does value need a watcher???
-->
<template>
	<span
		class="c-Badge"
		:class="badgeClassObject">{{ finalValue }}</span>
</template>

<script>
import { formatNumber } from '../../utils/utils';

export default {
	name: 'Badge',
	props: {
		/**
     * Badge type (colors)
     * @values is-default, is-primary, is-inverted, is-added -> (deprecated), is-success, is-important, is-removed
     */
		type: {
			type: String,
			required: false,
			default: 'is-default',
			validator(type) {
				return [
					'is-default',
					'is-primary',
					'is-inverted',
					'is-important',
					'is-added', // deprecated
					'is-success',
					'is-removed',
				].includes(type);
			},
		},
		/**
     * the Badge value
     */
		value:{
			type: [Number, String],
			required: true,
			default: '',
		},
		/**
     * if the Badge should format it's value as a number (value must also be a number)
     * @values true, false
     */
		formatNumber: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	computed: {
		badgeClassObject() {
			return {
				'is-default': this.type === 'is-default',
				'is-primary': this.type === 'is-primary',
				'is-inverted': this.type === 'is-inverted',
				'is-important': this.type === 'is-important',
				'is-success': this.type === 'is-success' || this.type === 'is-added', // deprecated
				'is-removed': this.type === 'is-removed',
			};
		},
		finalValue() {
			const finalValue = (this.formatNumber && typeof this.value === 'number')
				? formatNumber(this.value)
				: this.value;

			if (this.type === 'is-success' || this.type === 'is-added' /* deprecated */) {
				return `+${finalValue}`;
			}

			if (this.type === 'is-removed') {
				return `-${finalValue}`;
			}

			return finalValue;
		},
	},
}
</script>

<style lang="scss" scoped>
@import '../../scss/variables.scss';

.c-Badge {
  $fontsize-overline: 10px;

  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: calc(#{$border-radius} * 4);
  padding: 0 calc(#{$base-padding} * 0.375);
  background-color: $un-n300;
  line-height: 15px;
	min-width: 8px;
	color: $un-n900;
	font-family: $secondary-font;
	font-weight: 600;
	font-size: $fontsize-overline;
	text-decoration: none;
	user-select: none;

  &.is-primary {
    background-color: $un-blue;
		color: $un-white;
  }

  &.is-inverted {
    background-color: $un-white;
    -webkit-box-shadow: inset 0px 0px 0px 0.5px $un-n900;
    -moz-box-shadow: inset 0px 0px 0px 0.5px $un-n900;
    box-shadow: inset 0px 0px 0px 0.5px $un-n900;
    color: $un-blue;
  }

  &.is-important {
    background-color: $un-yellow;
  }

  &.is-success {
    background-color: $un-green-lighter;
		color: $un-green-darker;
  }

  &.is-removed {
    background-color: $un-red;
		color: $un-red-darker;
  }
}
</style>
